export default __webpack_public_path__ + "static/icon-ca3e17ad1c61f3b4da8e041619d717df.png";